/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components */
// Extends from
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember imports
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { setDiff } from '@ember/object/computed';
export default class SelectDialogue extends Component {
  // Attributes
  // Passed in
  buttonLabel = '';

  templateType = '';
  templates = [];
  usageSets = [];
  @tracked
  selectedTemplates = [];
  sortByAttr = '';

  // Dialogue attributes
  @tracked
  selectedUsageSetsFilter = [];

  @setDiff('usageSets', 'selectedUsageSetsFilter')
  remainingUsageSetsFilter;

  @tracked
  dialogueOpen = false;

  @computed('templates.[]', 'selectedUsageSetsFilter.[]')
  get filteredTemplates() {
    return this.get('templates').filter((template) => {
      if (!isEmpty(this.selectedUsageSetsFilter)) {
        return this.selectedUsageSetsFilter.some((usageSet) =>
          template.get('usageSetsArray').includes(usageSet),
        );
      }
      return true;
    });
  }

  @action
  openDialog() {
    this.dialogueOpen = true;
  }

  @action
  toggleTemplate(template, checked) {
    if (checked) {
      this.selectedTemplates = [...this.selectedTemplates, template];
    } else {
      this.selectedTemplates = this.selectedTemplates.filter(
        (t) => t !== template,
      );
    }
  }

  @action
  addUsageSetFilter(usageSet) {
    this.selectedUsageSetsFilter = [...this.selectedUsageSetsFilter, usageSet];
  }

  @action
  removeUsageSetFilter(usageSet) {
    this.selectedUsageSetsFilter = this.selectedUsageSetsFilter.filter(
      (u) => u !== usageSet,
    );
  }

  @action
  toggleAllTemplates(templates, checked) {
    if (checked) {
      this.selectedTemplates = [...templates];
    } else {
      this.selectedTemplates = [];
    }
  }
}
